<template>
  <b-form class="inline-input-container" @submit.prevent="updatePercentage">
      <input
        v-model="inputValue"
        :title="title"
        v-b-tooltip.hover.bottom
        type="number"
        min="0"
        max="100"
        :disabled="isUploading"
        :maxlength="4"
        @mouseover="focused = true"
        @mouseout="focused = false"
        placeholder="%"
      >
  </b-form>
</template>

<script>
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums';

export default {
  name: 'ShareholdersPercentageForm',
  props: {
    childId: {
      type: String,
      required: true
    },
    parentId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      focused: false,
      inputValue: null,
      isUploading: false
    };
  },

  computed: {
    title() {
      return this.focused ? 'Presione enter para guardar' : ''
    }

  },

  methods: {
    ...mapActions(['setShareholderPercentage']),

    async updatePercentage() {
      if (this.inputValue === null ) {
        this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg: 'Debe ingresar un porcentaje', type: 'warning'});
        return
      }

      this.isUploading = true;

      let data = {
        parentNodeId: this.parentId,
        childNodeId: this.childId,        
        participation: new Number(this.inputValue)
      }
      let result = await this.setShareholderPercentage(data)

      if (result.isError) {
        this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg: result.message, type: 'danger'})
        this.isUploading = false
        return
      }

      this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg:'Porcentaje asignado correntamente', type: 'success'})
      this.$eventBus.$emit(EventNames.UpdatedPercentage, data)
      this.inputValue = null
      this.isUploading = false
    }
  }
};
</script>

<style scoped>
.inline-input-container {
  display: inline-flex;
  align-items: center;
}

input {
  width: 50px;
  border-radius: 15%;
  border: none;
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 12px;
}

svg {
  color: gray
}

svg:hover {
  color: black
}

input:focus {
  outline: none;
}
</style>